import { Button, Col, Flex, Input } from "antd";
import React from "react";
import PrimaryButton from "../Buttons/PrimaryButton";

export default function GeneratedDescriptionCard({
	handleProductUpdate,
	newDescription,
	setNewDescription,
}) {
	return (
		<Flex vertical gap={"12px"} style={{ position: "relative" }}>
			<Col span={24}>
				<Input.TextArea
					value={newDescription}
					autoSize={{
						minRows: 2,
						maxRows: 10,
					}}
					style={{
						paddingBottom: "50px", // Add space for the button
					}}
					rows={4}
					onChange={(e) => setNewDescription(e?.target?.value)}
				/>
				<div
					style={{
						position: "absolute",
						right: 0,
						bottom: 0,
						margin: "8px",
						zIndex: 1,
					}}
				>
					<PrimaryButton onClick={handleProductUpdate}>
						Update Product Description
					</PrimaryButton>
				</div>
			</Col>
		</Flex>
	);
}
